import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import WaterHeaterImage from '../../assets/images/rooms/water-heater.jpg';
import InductionImage from '../../assets/images/rooms/induction.jpg';
import DryerImage from '../../assets/images/rooms/dryer.jpg';
import HvacImage from '../../assets/images/rooms/hvac.jpg';
import SolarImage from '../../assets/images/rooms/solar.jpg';
import EvImage from '../../assets/images/rooms/ev.jpg';
import Button from '../../components/Button';
import NavButton from './NavButton';

const ROOM_IMAGES = {
  water: WaterHeaterImage,
  induction: InductionImage,
  laundry: DryerImage,
  hvac: HvacImage,
  solar: SolarImage,
  ev: EvImage,
};

const ROOM_IMAGE_ALTS = {
  water: 'Image of a water heater',
  induction: 'Image of an induction cooktop',
  laundry: 'Image of a dryer',
  hvac: 'Image of an HVAC system',
  solar: 'Image of solar panels',
  ev: 'Image of an electric vehicle',
};

const RoomCard = ({ img, imgAlt, title, subtitle, isSelected, onClick }) => (
  <Box
    sx={{
      border: isSelected ? '2px solid' : '1px solid',
      borderColor: isSelected ? 'orange.500' : 'grey.300',
      borderRadius: '4px',
      px: isSelected ? '7px' : '8px', // adjust padding for border thickness
      py: isSelected ? '15px' : '16px',
      display: 'flex',
      margin: '0 auto',
      maxWidth: { xs: '240px', sm: 'none' },
      flexDirection: 'column',
      alignItems: 'center',
      boxShadow: isSelected ? '0px 4px 12px 0px #0000000D' : 'none',
      transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
    }}
  >
    <Box
      component="img"
      src={img}
      alt={imgAlt}
      sx={{
        height: '150px',
        width: '100%',
        objectFit: 'cover',
        borderRadius: '8px',
        overflow: 'hidden',
        mb: 2,
      }}
    />
    <Typography mb={1} variant="h5" fontWeight={600}>
      {title}
    </Typography>
    <Typography mb={2} variant="body2" textAlign="center">
      {subtitle}
    </Typography>
    <Button
      onClick={onClick}
      sx={{
        border: '1px solid',
        borderColor: isSelected ? 'orange.500' : 'blue.550',
        bgcolor: isSelected ? 'orange.500' : 'transparent',
        color: isSelected ? 'common.black' : 'blue.550',
        borderRadius: '2px',
        px: 2.5,
        py: 0.5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontWeight: 700,
        fontSize: '0.875rem',
        textTransform: 'none',
        '&:hover, &:focus-visible': {
          bgcolor: isSelected ? 'orange.700' : 'grey.200',
          borderColor: isSelected ? 'orange.700' : 'blue.550',
        },
      }}
    >
      {isSelected ? 'Remove' : 'Add'}
    </Button>
  </Box>
);

export default function SelectRoomsStep({ onNext, rooms, myProject, toggleRoom }) {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Box maxWidth="750px" sx={{ margin: '0 auto' }}>
      <Grid container spacing={3}>
        {rooms.map((room) => (
          <Grid item xs={12} sm={6} md={4} key={room.handle} display="flex">
            <RoomCard
              id={room.handle}
              img={ROOM_IMAGES[room.handle]}
              imgAlt={ROOM_IMAGE_ALTS[room.handle]}
              title={room.title}
              subtitle={room.subtitle}
              isSelected={myProject.some((r) => r.handle === room.handle)}
              onClick={() => toggleRoom(room)}
            />
          </Grid>
        ))}
      </Grid>

      <NavButton
        disabled={myProject.length === 0}
        onClick={onNext}
        variant="primary"
        sx={{
          backgroundColor: myProject.length === 0 ? 'orange.300' : 'orange.500',
        }}
      >
        {isSmallScreen ? 'Get Started' : 'Continue'} ({myProject.length})
      </NavButton>
    </Box>
  );
}
